import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User, AuthState } from "../types";

const initialState: AuthState = {
	user: null,
	token: localStorage.getItem("token"),
	isAuthenticated: !!localStorage.getItem("token"),
	isLoading: false,
	error: null,
};

const authSlice = createSlice({
	name: "auth",
	initialState,
	reducers: {
		loginStart: (state) => {
			state.isLoading = true;
			state.error = null;
		},
		loginSuccess: (
			state,
			action: PayloadAction<{ user: User; token: string }>
		) => {
			state.isLoading = false;
			state.isAuthenticated = true;
			state.user = action.payload.user;
			state.token = action.payload.token;
			state.error = null;
			localStorage.setItem("token", action.payload.token);
		},
		loginFailure: (state, action: PayloadAction<string>) => {
			state.isLoading = false;
			state.error = action.payload;
			state.isAuthenticated = false;
			state.user = null;
			state.token = null;
		},
		logout: (state) => {
			state.user = null;
			state.token = null;
			state.isAuthenticated = false;
			state.error = null;
			localStorage.removeItem("token");
		},
		clearError: (state) => {
			state.error = null;
		},
	},
});

export const { loginStart, loginSuccess, loginFailure, logout, clearError } =
	authSlice.actions;
export default authSlice.reducer;
